import * as z from "zod";

export const PortalBuilderFlatTeamSettingsSchema = z.object({
  "returns/disableRejectedItems": z.boolean().nullish(),
  bulkReturnsEnabled: z.boolean().nullish(),
  "returns/bulkReturns/collections": z.array(z.string()).nullish(),
  "returns/bulkReturns/hideQuantity": z.boolean().nullish(),
  "warranties/showOtherOption": z.boolean().nullish(),
  "warranties/mailingListSignUpEnabled": z.boolean().nullish(),
  "warranties/cantFindItemButtonEnabled": z.boolean().nullish(),
  "warranties/askShopperForPricePaid": z.boolean().nullish(),
  "warranties/allowQuantitySelect": z.boolean().nullish(),
  "warranties/maxQuantitySelect": z.number().nullish(),
  portalExcludedProductTags: z.array(z.string()).nullish(),
  portalExcludedProductIds: z.array(z.string()).nullish(),
  portalExcludedCollections: z.array(z.string()).nullish(),
  "resourceOverride/COMMON": z.record(z.string(), z.string()).nullish(),
});
